import { DateFns, ConstantFormat } from "../DateFns";

type FileNameOptions = {
	title?: string;
	dateFrom?: string | number | Date | null;
	dateTo?: string | number | Date | null;
	format?: "pdf" | "xlsx";
};

/**
 * Generates a formatted filename based on provided parameters.
 * @param {FileNameOptions} options - The file name options.
 * @returns {string} The formatted file name.
 */
const generateFileNameFileHelper = ({
	title = "",
	dateFrom = new Date(),
	dateTo = new Date(),
	format,
}: FileNameOptions): string => {
	const dateFns = new DateFns();

	const isValidDateFrom =
		dateFrom instanceof Date && !Number.isNaN(dateFrom.getTime());
	const isValidDateTo =
		dateTo instanceof Date && !Number.isNaN(dateTo.getTime());

	const _dateFrom = isValidDateFrom ? dateFrom : new Date();
	const _dateTo = isValidDateTo ? dateTo : new Date();

	if (!isValidDateFrom)
		console.error("Invalid dateFrom value: Expected a valid Date object.");
	if (!isValidDateTo)
		console.error("Invalid dateTo value: Expected a valid Date object.");

	const formattedDateFrom = dateFns.formatTime2(
		_dateFrom,
		ConstantFormat.MDY_UK,
	);

	const formattedDateTo = dateFns.formatTime2(_dateTo, ConstantFormat.MDY_UK);

	let fileName = `${title.trim()} - ${formattedDateFrom} - ${formattedDateTo}`
		.replace(/\s+/g, " ")
		.trim();

	if (typeof format === "string") {
		fileName = `${fileName}.${format.toLowerCase()}`;
	}

	return fileName;
};

export default generateFileNameFileHelper;
